import { useEffect, useState, useContext } from "react";
import ReportHeader from "../../components/ReportHeader";
import { formatDate } from "../../constant";
import { AuthContext } from "../../context/AuthContext";
import useAxios from "../../common/hook/useAxios";
import { toast } from "react-toastify";
import { FaFilePdf, FaTrash } from "react-icons/fa";
import { useSearchParams } from "react-router-dom";
import DeletePopup from "../../components/DeletePopup";

const BloodReport = () => {
  const [searchParams] = useSearchParams()
  const patientId = searchParams.get("patientId") ?? "";
  const patientName = searchParams.get("patientName") ?? "";
  const { request } = useAxios();
  const { user } = useContext(AuthContext);
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [bloodTableData, setBloodTableData] = useState([]);
  const [searchBlood, setSearchBlood] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [searchDOS, setSearchDOS] = useState("");
  const [searchResult, setSearchResult] = useState("");
  const [searchNote, setSearchNote] = useState("");
  const [selectedRows, setSelectedRows] = useState({});
  const [selectAll, setSelectAll] = useState(false);
  const [selectedRow, setSelectedRow] = useState([])
  const [deletePopup, setDeletePopup] = useState(false)
  useEffect(() => {
    if (user) {
      getBloodReportData();
    }
  }, [user]);
  const getBloodReportData = async () => {
    const formattedFromDate = await formatDate(fromDate);
    const formattedToDate = await formatDate(toDate);
    const url = `${process.env.REACT_APP_TEMPLATES_URL}/LabResults/BloodDetails?sInputJSON={'objLab':{'PatientID':${patientId ? patientId : "0"},'PracticeID':${user?.PracticeID},'ResultType':0,'FromDOS':'${formattedFromDate}','ToDOS':'${formattedToDate}','LocID':0,'TimeZoneOffSet':${user?.DefaultTimeZoneOffSet} }}`;
    request(url, {
      headers: {
        Authorization: `Bearer ${user?.AuthToken}`,
      },
      method: "GET",
    })
      .then((res) => {
        setBloodTableData(res);
      })
      .catch((err) => {
        console.log(err);
        toast.error("Error occurred while getting data", {
          autoClose: 3000,
        });
      });
  };

  const handleSelectAll = () => {
    // If any patient is already selected, toggle the selection
    const shouldSelectAll =
      selectedRows && Object.values(selectedRows).some((value) => value);

    const newSelection = filteredPatients
      // .filter((item) => item.MissingDataDetails?.length == 0)
      .reduce((acc, row) => {
        acc[row.DocumentID] = shouldSelectAll ? false : true; // If any selected, set all to false; otherwise, set all to true
        return acc;
      }, {});
    setSelectedRows(newSelection);
    setSelectAll(!shouldSelectAll);
  };
console.log(selectedRows);

  const handleRowSelect = (row) => {
    setSelectedRows((prevState) => ({
      ...prevState,
      [row?.DocumentID]: !prevState[row?.DocumentID],
    }));
    setSelectedRow((prevSelectedRows) => {
      const isAlreadySelected = prevSelectedRows.some(
        (selectedRow) => selectedRow.DocumentID === row.DocumentID
      );

      if (isAlreadySelected) {
        // Remove the row if it's already selected
        return prevSelectedRows.filter(
          (selectedRow) => selectedRow.DocumentID !== row.DocumentID
        );
      } else {
        // Add the row to the selection
        return [...prevSelectedRows, row];
      }
    });
  };

  const filteredPatients =
    bloodTableData?.length > 0 &&
    bloodTableData?.filter((row) => {
      const fullName = `${row.FirstName} ${row.LastName}`?.toLowerCase();
      const searchTermNormalized = searchTerm?.trim()?.toLowerCase();
      const dosMatches = row?.DOS?.trim()
        .toLowerCase()
        .includes(searchDOS?.trim()?.toLowerCase());
      const resultMatches = row?.RequisitionNumber?.trim()
        ?.toLowerCase()
        .includes(searchResult?.trim()?.toLowerCase());
      // const noteMatches = row?.RequisitionNumber?.trim()
      //   ?.toLowerCase()
      //   .includes(searchNote?.trim()?.toLowerCase());
      return (
        fullName.includes(searchTermNormalized) &&
        dosMatches
        && (resultMatches || (!searchResult && row?.RequisitionNumber === null))
      );
    });

  const handlePopup = () => {
    // console.log(selectedRow?.length > 0);

    if (selectedRow?.length < 1) {
      toast.error("No Document Selected")
    } else {
      setDeletePopup(true)
    }
  }

  const handleDelete = () => {
    if (selectedRow?.length < 1 && !selectAll) {
      toast.error("No Document Selected")
      onClose()
      return
    }
    const payload = selectAll ? filteredPatients
      .filter((item) => selectedRows[item.DocumentID] === true)
      .map((item) => {
        return {
          DocuementID: item.DocumentID,
          PatientID: item.PatientID,
          PracticeID: user?.PracticeID
        };
      }) : selectedRow.map((item) => ({
        DocuementID: item.DocumentID,
        PatientID: item.PatientID,
        PracticeID: user?.PracticeID
      }));

    const url = `${process.env.REACT_APP_TEMPLATES_URL}/LabResults/BloodReports?sInputJSON=${encodeURIComponent(JSON.stringify({ objLab: payload }))}`;

    request(url, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload), // Sending the payload in the body
    })
      .then(() => {
        getBloodReportData()
        onClose()
        setSelectAll(false)
        toast.success("Files Deleted Successfully")
      })
      .catch((err) => {
        console.log(err);
        toast.error("Error occurred while delete doc", {
          autoClose: 3000,
        });
      });
  }
  const onClose = () => {
    setDeletePopup(false)
  }
  return (
    <div>
      <DeletePopup isOpen={deletePopup} toggleMenu={onClose} handleDelete={handleDelete} />
      <ReportHeader
        title1="Scan And Upload Blood Report"
        title2="Search Blood Report"
        fromDate={fromDate}
        setFromDate={setFromDate}
        toDate={toDate}
        setToDate={setToDate}
        search={searchBlood}
        setSearch={setSearchBlood}
        getReportData={getBloodReportData}
        uploadUrl="BloodResults"
        refreshData={getBloodReportData}
        id={patientId}
        name={patientName}
      />
      {/* <LabReport />
      <CustomTable thirdData={bloodTableData} table_heading={table_heading} /> */}
      <div className="overflow-auto">
        <table className="min-w-full bg-white border border-gray-300">
          <thead>
            <tr className="bg-[#005d97] border-b border-black text-white">
              <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                #
              </th>
              <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                Location
              </th>
              {!patientId &&
                <th
                  style={{ whiteSpace: "nowrap" }}
                  className="p-2 border-r border-black flex flex-col"
                >
                  Patient Name
                  <input
                    type="text"
                    className="text-gray-800 text-sm mt-1"
                    placeholder="Search by Patient Name"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{ marginBottom: "10px", padding: "5px" }}
                  />
                </th>
              }
              <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                File Name
              </th>
              <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                DOS <br></br>
                <input
                  type="text"
                  className="text-gray-800 text-sm mt-1"
                  placeholder="Search"
                  value={searchDOS}
                  onChange={(e) => setSearchDOS(e.target.value)}
                  style={{ marginBottom: "10px", padding: "5px" }}
                />
              </th>
              <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                Request
              </th>
              {/* <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                Request Date
              </th> */}
              <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                Result<br></br>
                <input
                  type="text"
                  className="text-gray-800 text-sm mt-1"
                  placeholder="Search"
                  value={searchResult}
                  onChange={(e) => setSearchResult(e.target.value)}
                  style={{ marginBottom: "10px", padding: "5px" }}
                />
              </th>
              <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                <div className="flex flex-row items-center justify-between">
                  Result Note <br></br>
                  <div className="flex flex-row gap-1">
                    <p className="bg-green-400 rounded-full p-2.5"></p>
                    <p className="bg-red-400 rounded-full p-2.5"></p>
                  </div>
                </div>
                <input
                  type="text"
                  className="text-gray-800 text-sm mt-1"
                  placeholder="Search"
                  value={searchNote}
                  onChange={(e) => setSearchNote(e.target.value)}
                  style={{ marginBottom: "10px", padding: "5px" }}
                />
              </th>
              <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">

                <input
                  type="checkbox"
                  onChange={handleSelectAll}
                  checked={selectAll}
                />
                <FaTrash className="cursor-pointer" onClick={handlePopup} />
              </th>
            </tr>
          </thead>{" "}
          <tbody>
            {bloodTableData && Array.isArray(bloodTableData) ? (
              ((searchTerm || searchDOS || searchResult || searchNote) !== ""
                ? filteredPatients
                : bloodTableData
              )?.map((row, index) => (
                <tr key={row.DocumentID} data-tooltip-place="top">
                  <td
                    style={{ whiteSpace: "nowrap" }}
                    className="p-2 border-r border-b border-black"
                  >
                    {index + 1}
                  </td>
                  <td
                    style={{ whiteSpace: "nowrap" }}
                    className="p-2 border-r border-b border-black"
                  >
                    {row.location}
                  </td>
                  {!patientId &&
                    <td
                      style={{ whiteSpace: "nowrap" }}
                      className="p-2 border-r border-b border-black cursor-pointer text-blue-700 underline"
                      onClick={() => {
                        const url = `/patient-dashboard?patientId=${row?.PatientID}&patientName=${encodeURIComponent(row?.FirstName + row?.LastName)}`;
                        window.open(url, "_blank");
                      }}
                    >
                      {`${row?.LastName || ""}, ${row?.FirstName || ""}`}
                    </td>
                  }
                  <td
                    style={{ whiteSpace: "nowrap" }}
                    className="p-2 border-r border-b border-black"
                  >
                    {row?.DocumentName}
                  </td>
                  <td
                    style={{ whiteSpace: "nowrap" }}
                    className="p-2 border-r border-b border-black"
                  >
                    {row?.DOS}
                  </td>
                  <td
                    style={{ whiteSpace: "nowrap" }}
                    className="p-2 border-r border-b border-black"
                  >
                    {row?.ResultWebPath && (
                      <a
                        href={row.ResultWebPath}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="cursor-pointer"
                      >
                        <FaFilePdf className="text-red-400" />
                      </a>
                    )}
                  </td>
                  <td
                    style={{ whiteSpace: "nowrap" }}
                    className="p-2 border-r border-b border-black"
                  >
                    {row?.RequisitionNumber}
                  </td>
                  <td
                    style={{ whiteSpace: "nowrap" }}
                    className="p-2 border-r border-b border-black"
                  >
                    {row?.ResultResponse === 2 && (
                      <p className="bg-green-400 rounded-full p-2"></p>
                    )}
                    {row?.ResultResponse === 3 && (
                      <p className="bg-red-400 rounded-full p-2"></p>
                    )}
                  </td>
                  <td
                    style={{ whiteSpace: "nowrap" }}
                    className="p-2 border-r border-b border-black"
                  >
                    <input
                      // disabled={row.MissingDataDetails?.length > 0}
                      type="checkbox"
                      checked={!!selectedRows[row.DocumentID]}
                      onChange={() => handleRowSelect(row)}
                    />
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={10} className="p-2 text-center">
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BloodReport;
